import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { Link } from 'react-router-dom';
import { TeamsElement } from '@/features/w/[identifier]/setting/teams/{components}/TeamsElement';

export const WorkspaceTeams = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('チーム設定'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'team'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">チーム一覧</h5>
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  {me!.admin && (
                    <Link to={`/w/${_w_!.identifier}/setting/teams/new`} className="btn bg-gradient-primary btn-icon">
                      <i className="fas fa-plus"></i>チーム新規登録
                    </Link>
                  )}
                </div>
              </div>

              <TeamsElement />
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
